import React from 'react';
import { useChartInteractions } from '../hooks/useChartInteractions';

interface ChartContentProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Reusable chart content area component with consistent styling and interactions
 * Provides the standard chart content styling with interaction prevention
 */
export const ChartContent: React.FC<ChartContentProps> = ({
  children,
  className = '',
}) => {
  const chartInteractions = useChartInteractions();

  return (
    <div
      className={`flex-1 px-4 ${className}`}
      style={chartInteractions.chartStyle}
      onMouseDown={chartInteractions.onMouseDown}
      onClick={chartInteractions.onClick}
    >
      {children}
    </div>
  );
};
